import { render, staticRenderFns } from "./PurchaseApplication.vue?vue&type=template&id=b4242346&scoped=true&"
import script from "./PurchaseApplication.vue?vue&type=script&lang=js&"
export * from "./PurchaseApplication.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseApplication.vue?vue&type=style&index=0&id=b4242346&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4242346",
  null
  
)

export default component.exports